import { Box } from '@mui/material'
import {
  TemplateOutputs,
  TemplateSummaryOutputs,
} from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'
import {
  GraphData,
  SequenceOfEventsGraph,
} from 'Features/Projects/Scenarios/Templates/TemplateResults/Results/Results.SequencedGraphView'

// SORT OUT WHERE SequenceOfEventsGraph should go

export const TotalledGraphView = ({
  templateOutputsData,
  templateSummaryData,
}: {
  templateOutputsData: TemplateOutputs[]
  templateSummaryData: TemplateSummaryOutputs[]
}) => {
  const convertToAggregatedGraphData = (
    templateOutputs: TemplateOutputs[]
  ): GraphData => {
    const groupedByWeek = templateOutputs.reduce(
      (acc, item) => {
        const week = item.weekNo
        if (!acc[week]) {
          acc[week] = {
            productionTime: 0,
            changeOverTime: 0,
            inBatchChangeOverTime: 0,
          }
        }

        acc[week].productionTime += item.productionTimeInHrs || 0
        acc[week].changeOverTime += item.changeOverTimeInHours || 0
        acc[week].inBatchChangeOverTime +=
          item.inBatchChangeOverTimeInHours || 0

        return acc
      },
      {} as Record<
        number,
        {
          productionTime: number
          changeOverTime: number
          inBatchChangeOverTime: number
        }
      >
    )

    return Object.entries(groupedByWeek).map(([weekStr, totals]) => ({
      week: parseInt(weekStr, 10),
      graphData: [
        {
          productCode: `Week ${weekStr} Total`,
          sequence: 1,
          productionTime: totals.productionTime,
          changeOverTime: totals.changeOverTime,
          inBatchChangeOverTime: totals.inBatchChangeOverTime,
        },
      ],
    }))
  }

  const graphData = convertToAggregatedGraphData(templateOutputsData)
  const summary = templateSummaryData[0]
  return (
    <Box display="flex" justifyContent="center" alignItems="center">
      <SequenceOfEventsGraph
        graphData={graphData}
        capacityReferenceValue={parseFloat(
          summary.workcentreCapacityInitial.toFixed(1)
        )}
        averageUtilisationPercentage={parseFloat(
          summary.utilisationVolatility.toFixed(1)
        )}
        averageUtilisationHours={parseFloat(
          summary.avgUtilisationHoursNonFOQPerWeek.toFixed(1)
        )}
      />
    </Box>
  )
}
